const { Component } = React;

export default class CheckInPopover extends Component {
  state = { checkOut: 'select' };

  componentWillMount = () => {
    const { checkOuts } = this.props;

    if (checkOuts.length === 1) {
      this.setState({ checkOut: checkOuts[0] });
    }
  };

  componentDidMount = () => {this.setArrow();}
  componentDidUpdate = () => {this.setArrow();}

  setArrow = () => {
    const { calendarLeft, left } = this.props;

    $('head').append(`<style>.rct-popup:before{left:${left - calendarLeft}px;}</style>`);
  }

  getOptions() {
    return this.props.checkOuts.map((checkout, index) => {
      return (
        <option key={index} value={this.replaceDash(checkout)}>
          {this.replaceDash(checkout)}
        </option>
      );
    });
  }

  selectCheckout(e) {
    this.setState({ checkOut: e.target.value });
  }

  obeRedirect = url => () => {
    window.location.href = url;
  };

  replaceDash = date => date.replace(/-/g, '/');

  render() {
    const { calendarLeft, top, checkIn, checkOuts, rstCode } = this.props;
    const { checkOut } = this.state;
    const isMobile = window.innerWidth < 768;
    const bookNow = `/book-now/?reference=obe&startDate=${this.replaceDash(checkIn)}&endDate=${checkOut}&isMobile=${isMobile}&resortCode=${rstCode}`;
    const singleOption =
      checkOuts.length === 1 ? (
        <input
          type="text"
          disabled
          value={this.replaceDash(checkOuts[0])}
          id="check-out"
          name="check-out"
        />
      ) : (
        ''
      );
    const popupOffset = isMobile ? 403 : 430;
    const dateTop = top - popupOffset;
    const width =
      document.getElementsByClassName('slider-calendar-item')[0].offsetWidth +
      'px';

    return (
      <div className="rct-popup" style={{ left: calendarLeft, top: dateTop, width: width }}>
        <div className="popover-content-wrap">
          <div className="popover-content-top">
            <i className="ic icon-close" onClick={this.props.closePopup} />
            <h2>1 night free</h2>
            <p>During the following stay:</p>
          </div>
          <div className="popover-content-inner">
            <div className="popover-form">
              <div className="booking-date">
                <label htmlFor="check-in">check-in:</label>
                <input
                  type="text"
                  disabled
                  value={this.replaceDash(checkIn)}
                  id="check-in"
                  name="check-in"
                />
              </div>
              <div className="booking-date">
                <label htmlFor="check-out">check-out:</label>
                {singleOption || (
                  <div className="dateinput">
                    <select
                      className="js-custom-select-popover"
                      name="check-out"
                      id="check-out"
                      value={checkOut}
                      onChange={e => this.selectCheckout(e)}
                    >
                      <option disabled value="select">
                        Select Date
                      </option>
                      {this.getOptions()}
                    </select>
                  </div>
                )}
              </div>
              <button
                type="submit"
                name="button"
                className="booking-date__submit"
                onClick={() => {
                  window.location.href = bookNow;
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
